import jss from 'src/lib/services/Jss'
import { colors } from 'src/colors'

const { classes } = jss
  .createStyleSheet({
    checked: {
      color: colors.primary.main,
    },
  })
  .attach()

export const cn = classes



// WEBPACK FOOTER //
// ./src/lib/components/controls/Checkbox.style.js